"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketEncryptionInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=GetBucketEncryptionInput.js.map